import _defineProperty from "@babel/runtime/helpers/defineProperty";
import cc from 'classcat';
import PropTypes from 'prop-types';
import css from './Form.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var Field = function Field(_ref) {
  var ariaLabel = _ref.ariaLabel,
      autoComplete = _ref.autoComplete,
      helpText = _ref.helpText,
      id = _ref.id,
      label = _ref.label,
      onChange = _ref.onChange,
      required = _ref.required,
      type = _ref.type,
      value = _ref.value;
  var isTextarea = type === 'textarea';
  var HtmlTag = isTextarea ? 'textarea' : 'input';
  return /*#__PURE__*/_jsx("div", {
    className: css.field,
    children: /*#__PURE__*/_jsxs("label", {
      className: css.label,
      htmlFor: "pdp-qanda-".concat(id),
      children: [/*#__PURE__*/_jsx("span", {
        className: css.labelText,
        children: label
      }), /*#__PURE__*/_jsx(HtmlTag, {
        "aria-label": ariaLabel,
        autoComplete: autoComplete,
        className: cc([css.input, _defineProperty({}, css.textarea, isTextarea)]),
        id: "pdp-qanda-".concat(id),
        name: id,
        onChange: onChange,
        required: required,
        type: type,
        value: value
      }), helpText && /*#__PURE__*/_jsx("span", {
        className: css.helpText,
        children: helpText
      })]
    })
  });
};

Field.defaultProps = {
  autoComplete: '',
  helpText: '',
  label: '',
  required: false
};
Field.propTypes = {
  ariaLabel: PropTypes.string.isRequired,
  autoComplete: PropTypes.string,
  id: PropTypes.string.isRequired,
  helpText: PropTypes.string,
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  type: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired
};
export default Field;